"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateActiveFilter = void 0;
const common_types_1 = require("@as-react/common-types");
const productSearch_util_1 = require("./productSearch.util");
const convertRawFilterValueUrlToCleanArray = (rawFilterValue) => {
    let resultList;
    switch (true) {
        case rawFilterValue.startsWith('('):
        case rawFilterValue.startsWith('['):
        case rawFilterValue.startsWith('{'):
            resultList = rawFilterValue.slice(1, -1).split(';');
            break;
        default:
            resultList = rawFilterValue.split(';');
            break;
    }
    return resultList;
};
const createFilteredItemsForRange = (filterValue) => {
    return convertRawFilterValueUrlToCleanArray(filterValue).map(key => ({
        filterKey: key,
    }));
};
const createFilteredItemsForMultiSelect = (values) => {
    return values
        .filter(value => value.active)
        .map(value => ({
        filterKey: value.filterKey,
        filterKeyName: value.name,
    }));
};
const mapSetFilterObjectToFilteredItemWithFilterType = (setFilterObject) => {
    let data = {
        filterType: setFilterObject.filterType,
        filterOnName: setFilterObject.filterOnName,
        filterContentType: setFilterObject.filterContentType,
    };
    if ((0, productSearch_util_1.isMultiSelectFilter)(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { values: [...setFilterObject.filteredItems] });
    }
    else if ((0, productSearch_util_1.isRangeFilter)(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { rangeMin: Math.trunc(Number(setFilterObject.filteredItems[0].filterKey)), rangeMax: Math.trunc(Number(setFilterObject.filteredItems[1].filterKey)), filterPrefix: setFilterObject.filterPrefix, filterSuffix: setFilterObject.filterSuffix });
    }
    return data;
};
const getFilterType = (type) => (type === 'RANGE' ? common_types_1.RANGE_FILTER : common_types_1.MULTISELECT_FILTER);
const generateActiveFilter = (filterOn, filterValue, filters) => {
    const usedFilter = filters.filter(filter => filter.filterOn === filterOn)[0];
    if (usedFilter) {
        const filterType = getFilterType(usedFilter.type);
        const filteredItems = filterType === common_types_1.RANGE_FILTER
            ? createFilteredItemsForRange(filterValue)
            : createFilteredItemsForMultiSelect(usedFilter.values);
        const setFilterObject = {
            filterType,
            filterOn,
            filterContentType: usedFilter.filterContentType,
            filterOnName: usedFilter.name,
            filteredItems: filteredItems.map(filteredItem => (Object.assign({}, filteredItem))),
            filterPrefix: usedFilter.filterPrefix,
            filterSuffix: usedFilter.filterSuffix,
        };
        return mapSetFilterObjectToFilteredItemWithFilterType(setFilterObject);
    }
    return null;
};
exports.generateActiveFilter = generateActiveFilter;
//# sourceMappingURL=filter.util.js.map